export var skeletonButtonStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'inline-block',
      background: v.buttonBackground,
      height: v.buttonHeight,
      width: v.buttonWidth
    }, p.size === 'small' && {
      height: v.buttonSmallHeight,
      width: v.buttonSmallWidth
    }, p.circular && Object.assign({
      width: v.buttonHeight,
      borderRadius: v.buttonCircularBorderRadius
    }, p.size === 'small' && {
      width: v.buttonSmallHeight
    }), p.iconOnly && Object.assign({
      width: v.buttonHeight
    }, p.size === 'small' && {
      width: v.buttonSmallHeight
    }), p.fluid && {
      width: '100%',
      maxWidth: '100%'
    });
  }
};